import { ARTICLES_NAV_KEY } from '@src/utils/constant/common';

const loader = (name: string) => async () => {
  // @ts-ignore
  const entrance = await import(/* webpackChunkName: "f.home" */ './');
  return entrance[name];
};

import { IRoute } from '@src/types';

export const childRoutes: IRoute[] = [
  {
    path: ':navKey/:tabKey',
    name: 'Index',
    load: loader('Index')
  }
];

export default {
  path: `/${ARTICLES_NAV_KEY}`,
  name: 'Articles',
  childRoutes
};
